import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { RideButton } from '@rimac-seguros/ride-system-components';

import { ReactComponent as Close } from '../../../assets/icons/gl_circle_cross.svg';
import DynamicIcon from '../../../components/atoms/DynamicIcon';
import { getTagActionName } from '../../../utils/analytics';

import './styles.scss';

const ModalDetailPlan = ({
  open, defaultSelect, authoring, onClose, onConfirm,
}) => {
  const [tab, setTab] = useState(0);
  const { title, plans } = authoring;

  const tabsContainerRef = useRef(null);

  useEffect(() => {
    const index = plans.findIndex((_) => _.name === defaultSelect);
    if (index !== -1) {
      setTimeout(() => {
        setTab(index);
        if (tabsContainerRef.current) {
          const selectedTabElement = tabsContainerRef.current.children[index];
          const scrollLeft = selectedTabElement.offsetLeft - tabsContainerRef.current.offsetWidth / 2 + selectedTabElement.offsetWidth / 2;
          tabsContainerRef.current.scrollTo({
            left: scrollLeft,
            behavior: 'smooth',
          });
        }
      }, 200);
    }
  }, [defaultSelect, plans]);

  const handleChangeTab = (position, planName) => {
    setTab(position);
    getTagActionName('Seguro Salud Flexible', 'Interacciones', 'Modal Coberturas', planName, 'trackAction');
  };

  return open ? (
    <div className="modal-detail-plan">
      <div className="container">
        <div className="modal-detail-plan_close" onClick={onClose}>
          <span>Cerrar</span>
          <Close />
        </div>
        <div className="modal-detail-plan_container-wrapper">
          <div className="modal-detail-plan_header">
            <h3 className="modal-detail-plan_title">{title}</h3>
            <div className="modal-detail-plan_tabs" ref={tabsContainerRef}>
              {plans.map((_, i) => (
                <div key={`tab-${i}`} className={tab === i ? 'active' : ''} onClick={() => handleChangeTab(i, _.name)}>
                  <div>{_.name}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="modal-detail-plan_content">
            {plans[tab].coverages.map((_, i) => (
              <div key={`coverage-${i}`} className="modal-detail-plan_content-coverage">
                <div className="modal-detail-plan_content-coverage--head">
                  <DynamicIcon icon={_.icon} size="2x-large" />
                  <h4>{_.name}</h4>
                </div>
                <div className="modal-detail-plan_content-coverage--desc" dangerouslySetInnerHTML={{ __html: _.content }} />
              </div>
            ))}

            {plans[tab].othersCoverages?.length > 0 && (
              <div className="modal-detail-plan_content-others">
                <h3>Otras coberturas</h3>
                {plans[tab].othersCoverages.map((_, i) => (
                  <div key={`other-coverage-${i}`} className="modal-detail-plan_content-coverage">
                    <div className="modal-detail-plan_content-coverage--head">
                      <DynamicIcon icon={_.icon} size="2x-large" />
                      <h4>{_.name}</h4>
                    </div>
                    <div className="modal-detail-plan_content-coverage--desc" dangerouslySetInnerHTML={{ __html: _.content }} />
                  </div>
                ))}
              </div>
            )}

            {plans[tab].doesNotCover && (
              <div className="modal-detail-plan_content-last">
                <h3>{plans[tab].doesNotCover.title}</h3>
                <div dangerouslySetInnerHTML={{ __html: plans[tab].doesNotCover.content }} />
              </div>
            )}
          </div>

          <div className="modal-detail-plan_footer">
            <div className="container">
              <p>¿Te interesa este plan?</p>
              <RideButton text="Obtenlo ahora" size="large" onClick={onConfirm} />
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

ModalDetailPlan.propTypes = {
  open: PropTypes.bool.isRequired,
  defaultSelect: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  authoring: PropTypes.shape({
    title: PropTypes.string.isRequired,
    plans: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      coverages: PropTypes.arrayOf(PropTypes.shape({
        icon: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        content: PropTypes.string.isRequired,
      })).isRequired,
      othersCoverages: PropTypes.arrayOf(PropTypes.shape({
        icon: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        content: PropTypes.string.isRequired,
      })),
      doesNotCover: PropTypes.shape({
        title: PropTypes.string.isRequired,
        content: PropTypes.string.isRequired,
      }).isRequired,
    })).isRequired,
  }).isRequired,
};

export default ModalDetailPlan;
